import { render, staticRenderFns } from "./emitter.vue?vue&type=template&id=372b01bf&scoped=true"
import script from "./emitter.vue?vue&type=script&lang=js"
export * from "./emitter.vue?vue&type=script&lang=js"
import style0 from "./emitter.vue?vue&type=style&index=0&id=372b01bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b01bf",
  null
  
)

export default component.exports